import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import { Grid, Card, CardContent, Box } from '@mui/material';
import { makeStyles, Theme } from '@material-ui/core/styles';

import GraphViewKeyMetrics from './GraphViewKeyMetrics';
import { exchangeRates } from 'src/const';

const useStyles = makeStyles((theme: Theme) => ({
  cardContainer: {
    height: '100%',
    transition: 'transform 0.5s',
  },
  cardContainerFlipped: {
    transform: 'rotateY( 180deg )',
    transition: 'transform 0.5s',
  },
  rear: {
    height: '100%',
    width: '100%',
    transform: 'rotateY(180deg)',
    transition: 'height 0.5s, transform 0.5s',
  },
}));

const getUnit = (titleVal: string, currency: string): string => {
  if (titleVal.includes('Occupancy')) {
    return '%';
  } else {
    return exchangeRates[currency].symbol;
  }
};

const currency = 'USD';

const KeyMetricsBigMarketCard = ({ title, color, keyMetricsVal }) => {
  const classes = useStyles();
  const metricsKey = title;
  const [percentile, setPercentile] = useState(0.5);
  // 6 -> Last 6 months, 12 -> Last 12 months, 100 -> All history
  const [timePeriod, setTimePeriod] = useState(100);

  const [metricsAvg, setMetricsAvg] = useState<number>(0);

  if (timePeriod !== 100) {
    keyMetricsVal = keyMetricsVal.slice(keyMetricsVal.length - timePeriod);
  }

  const unit = getUnit(title, currency);

  useEffect(() => {
    let count = 0;
    let sum = 0;
    for (const currentValue of keyMetricsVal) {
      sum += currentValue[title];
      count++;
    }
    if (count == 0) {
      setMetricsAvg(NaN);
    }
    setMetricsAvg(prev => sum / count);
  }, [keyMetricsVal]);

  return (
    <Card
      sx={{
        overflow: 'visible !important',
      }}
    >
      <CardContent sx={{ minHeight: 170, padding: '0px !important', margin: 0 }}>
        <Grid
          container
          className={clsx(classes.cardContainer, {
            [classes.cardContainerFlipped]: true,
          })}
        >
          <Box className={classes.rear}>
            <GraphViewKeyMetrics
              title={title}
              aggregateData={metricsAvg}
              keyMetricsVal={keyMetricsVal}
              color={color}
              currency={currency}
              unit={unit}
              metricsKey={metricsKey}
              percentile={percentile}
              timePeriod={timePeriod}
              setTimePeriod={setTimePeriod}
            />
          </Box>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default KeyMetricsBigMarketCard;
